import * as React from 'react';

import Buttons from 'components/Buttons';
import { Props as ButtonProps } from 'components/Button';

type Props = {
  backButton?: React.ReactElement<ButtonProps>;
  actionButtons?: React.ReactElement<ButtonProps>[];
  children: React.ReactNode;
};

import './styles/WizardPageLayout.scss';

export default function WizardPageLayout(props: Props) {
  const { backButton, actionButtons } = props;
  return (
    <div className="WizardPageLayout">
      <div className="WizardPageLayout-content">{props.children}</div>
      {(backButton || actionButtons) && (
        <div className="WizardPageLayout-footer">
          <Buttons split>
            {backButton || <span />}
            {actionButtons && (
              <Buttons align="right">
                {actionButtons.map((button, index) => {
                  const key = index;
                  return <React.Fragment key={key}>{button}</React.Fragment>;
                })}
              </Buttons>
            )}
          </Buttons>
        </div>
      )}
    </div>
  );
}
